<template>
  <div class="list nebRuleList">
    <div class="list-header">
      <h1 class="list-header-title">Saved Searches • <span class="list-header-subtitle">{{ numRules }} Total</span></h1>
    </div>
    <hr style="margin: 15px 0; border: solid 0.5px #cecece">
    <p class="list-subtext">
      To create a new saved search go to the Measure tab, filter the assets as you wish, and then click the “Action” button. Click "Save Search" and fill out the form.
    </p>
    <el-table :data="rules"
              header-cell-class-name="list-table-header"
              cell-class-name="list-table-cell"
              class="list-table"
              name="Rules">
      <el-table-column
        width="307"
        label="Saved Search Name">
        <template slot-scope="scope">
          <div>
            <p>{{ scope.row.name }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Filters">
        <template slot-scope="scope">
          <p v-for="(f, idx) in humanizeFilters(scope.row)" :key="idx">
            {{ f }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        width="225"
        label="Sorted By">
        <template slot-scope="scope">
          <p>{{ scope.row.fieldSortBy || scope.row.metricSortBy | replace('_', ' ') | capitalizeAll }}</p>
        </template>
      </el-table-column>
      <el-table-column width="130">
        <template slot-scope="scope">
          <el-dropdown split-button type="plain" size="small"
                       @click="viewRule(scope.row)"
                       @command="handleCommand"
                       trigger="click">
            View
            <el-dropdown-menu slot="dropdown" class="dropdownMenu">
              <el-dropdown-item :command="{type: 'view', rule: scope.row}">View</el-dropdown-item>
              <el-dropdown-item :command="{type: 'edit', rule: scope.row}">Edit</el-dropdown-item>
              <el-dropdown-item :command="{type: 'delete', rule: scope.row}">Delete</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { humanizeFilter } from '@/helpers'

  export default {
    name: 'rules',
    data () {
      return {
        rules: [],
        selectedRule: null,
        feedDialogVisible: false,
        mouseMoved: false
      }
    },
    computed: {
      numRules () {
        return this.rules.length
      }
    },
    methods: {
      humanizeFilter,
      humanizeFilters (row) {
        return Object.keys(row)
          .map(f => humanizeFilter(f, row[f]))
          .filter(hf => hf !== null)
      },
      viewRule (rule) {
        this.$store.commit('measure/setFiltersFromSavedSearch', rule)
        this.$store.commit('measure/setSortFromSavedSearch', rule)
        this.$store.commit('measure/setFilter', { key: 'savedSearch', value: String(rule.id) })
        this.$router.push({ name: 'measure' })
      },
      handleCommand ({ rule, type }) {
        switch (type) {
          case 'edit':
          case 'view':
            this.viewRule(rule)
            break
          case 'delete':
            this.$confirm('Are you sure you want to delete the rule?')
              .then(() => {
                this.$http.delete(this.$endpoints.savedSearch.detail(rule.id))
                  .then(() => {
                    this.rules = this.rules
                      .filter(ss => ss.id !== rule.id)
                  })
              })
            break
          default:
            break
        }
      }
    },
    created () {
      this.$http.get(this.$endpoints.savedSearch.list(), { params: { parent_brand: this.brandId} })
        .then(response => {
          this.rules = response.data
      })
    }
  }
</script>

<style scoped lang="scss">
.nebRuleList {
  margin: 0 auto;
  padding-top: 20px;
  width: 1170px;
  height: 100%;
}
  .list {
    &-header {
      &-title {
        font-size: 20px;
        margin: 0;
      }
      &-subtitle {
        font-size: 16px;
        font-weight: normal;
        color: #9b9b9b;
      }
    }
    &-subtext {
      font-size: 12px;
    }
  }

  .feedDialog-url {
    background: #f5f7fa;
    padding: 10px;
    border-radius: 2px;
    border: 1px solid #e4e7ed;
  }
</style>

<style lang="scss">
  .list {
    &-table {
      border-top: 5px solid #5c5e62;
      &-header {
        font-size: 14px;
        font-weight: 600;
        color: #5c5e62;
      }
      &-cell {
        vertical-align: top !important;
        padding-top: 15px !important;
        font-size: 12px;
        p {
          margin: 0;
          margin-bottom: 5px;
          line-height: 12px;
        }
      }
    }
  }
  .nebRuleList {
    .el-dropdown {
      .el-button-group {
        .el-dropdown__caret-button {
          width: 30px;
        }
      }
    }
    .el-button--plain {
      background: #efefef !important;
    }

    .el-button:hover {
      background: #efefef !important;
      color: #606266 !important;
      border-color: #cecece !important;
    }
  }
</style>
